<template>
    <!-- BEGIN Customers Table-->
    <div class="container-fluid longterm-location-table">
        <!--<span>
              <strong>suggestions :</strong>
          </span>
        <span id="overlay-suggestions"></span>
        <br>-->
        <div class="search-results m-t-20">
            <!--<p class="bold">Pages Search Results</p>-->
            <div class="row">
                <div class="col-md-12">
                    <!-- START PANEL -->
                    <div class="panel panel-transparent">
                        <div class="panel-body">
                            <div class="table-responsive">
                                <table class="table table-hover table-condensed table-detailed search-table"
                                       id="detailedTable">
                                    <thead>
                                    <tr>
                                        <th>Bureau</th>
                                        <th>Disponibilité</th>
                                        <th title="Superficie">Superficie</th>
                                        <th title="Loyer">Loyer</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <template v-for="n in 5">
                                        <item @click="showDetails = index" :index="index" :customer="customer"
                                              :show-details="showDetails === index">
                                        </item>
                                        <template v-if="showDetails === index">
                                            <item-details :customer="customer" :index="index"
                                                          :key="index"></item-details>
                                        </template>
                                    </template>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <!-- Pagination -->
                        <div class="pagination p12">
                            <ul>
                                <li>Previous</li>
                                <li class="is-active">1</li>
                                <li>2</li>
                                <li>3</li>
                                <li>4</li>
                                <li>5</li>
                                <li>6</li>
                                <li>Next</li>
                            </ul>
                        </div>
                        <!-- END PANEL -->
                    </div>
                </div>
            </div>
        </div>
        <!-- END Customers Table !-->
    </div>
</template>

<style lang="scss" scoped>
    .longterm-location-table {
        padding: 0;
    }

    .panel-body {
        min-width: 600px;
        padding: 0;
    }

    .search-table {
        th {
            width: auto;
            overflow: hidden;
            hyphens: auto;
            &:first-child {
                width: 300px;
            }
            &:nth-child(2) {
                width: 200px;
            }
            &:nth-child(3) {
                width: 90px;
            }
            &:last-child {
                width: 90px;
            }
        }
    }

    .pagination {
        padding: 0;
        float: right;
    }

    .pagination ul {
        margin: 0;
        padding: 0;
        list-style-type: none;
    }

    .pagination li {
        display: inline-block;
        padding: 5px 18px;
        color: #222;
    }

    .p12 li:first-of-type, .p12 li:last-of-type, .p12 .is-active {
        background-color: #fb557a;
        color: #fff;
        border-radius: 3px;
    }
</style>


<script type="text/babel">
    import Item from './Item'

    export default {
        data () {
            return {
                showDetails: null
            }
        },
        components: {
            Item
        },
        props: ['customers']
    }
</script>




// WEBPACK FOOTER //
// client/components/LongTermLocationsList/LongTermLocationsTable.vue